import React, { useState } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Select,
  MenuItem,
  Typography,
  Paper,
  Menu,
  ListItemIcon,
  Button,
} from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DescriptionIcon from "@mui/icons-material/Description";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import { secondAxios } from "../../../../../api/axios";

export default function RoleCard({
  role,
  project,
  roleUsers,
  oldSelectedUser,
}) {
  const [availableUsers, setAvailableUsers] = useState([...roleUsers]);

  const [selectedUsers, setSelectedUsers] = useState(oldSelectedUser);
  const [selectedDropdown, setSelectedDropdown] = useState("");
  // menu state
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeUserId, setActiveUserId] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event, userId) => {
    setAnchorEl(event.currentTarget);
    setActiveUserId(userId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveUserId(null);
  };

  const handleSelect = (id) => {
    if (!id) return;

    const user = availableUsers.find((u) => u.id === id);
    if (!user) return;

    setSelectedUsers((prev) => [
      ...prev,
      {
        ...user,
        newRole: role,
      },
    ]);
    setAvailableUsers((prev) => prev.filter((u) => u.id !== id));
    setSelectedDropdown("");
  };

  const handleRemove = (id) => {
    const user = selectedUsers.find((u) => u.id === id);
    if (!user) return;

    setSelectedUsers((prev) => prev.filter((u) => u.id !== id));
    setAvailableUsers((prev) => [...prev, user].sort((a, b) => a.id - b.id));
  };

  const onSubmit = async () => {
    console.log("selectedUsers: ", selectedUsers);

    const res = await secondAxios.patch(
      "/project/" + project?.id,
      selectedUsers
    );
    console.log(res?.data);
  };
  return (
    <Box
      sx={{
        p: 1,
        maxWidth: 400,
        mx: "auto",
      }}
    >
      <Paper
        sx={{
          height: 150,
          overflowY: "auto",
        }}
      >
        <List dense>
          {selectedUsers.length === 0 && (
            <ListItem>
              <ListItemText
                primary="No members selected!"
                sx={{ textAlign: "center", pt: 2, fontStyle: "italic" }}
              />
            </ListItem>
          )}
          {selectedUsers.map((user) => (
            <ListItem
              key={user.id}
              secondaryAction={
                <IconButton
                  edge="end"
                  onClick={(e) => handleMenuOpen(e, user.id)}
                >
                  <MoreHorizIcon />
                </IconButton>
              }
            >
              <ListItemText primary={user.name} />
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <MenuItem onClick={handleMenuClose}>
                  <ListItemIcon>
                    <AssignmentIndIcon fontSize="small" />
                  </ListItemIcon>
                  View Details
                </MenuItem>
                <MenuItem onClick={handleMenuClose}>
                  <ListItemIcon>
                    <DescriptionIcon fontSize="small" />
                  </ListItemIcon>
                  Timesheet
                </MenuItem>
                <MenuItem onClick={() => handleRemove(user.id)}>
                  <ListItemIcon>
                    <DeleteIcon fontSize="small" color="error" />
                  </ListItemIcon>
                  Remove
                </MenuItem>
              </Menu>
            </ListItem>
          ))}
        </List>
      </Paper>

      {/* Dropdown */}
      <Box sx={{ mt: 3 }}>
        <Typography variant="subtitle1" gutterBottom>
          Add User
        </Typography>
        <Select
          value={selectedDropdown}
          onChange={(e) => handleSelect(e.target.value)}
          displayEmpty
          fullWidth
        >
          <MenuItem value="">
            <em>Select a user</em>
          </MenuItem>
          {availableUsers.map((user) => (
            <MenuItem key={user.id} value={user.id}>
              {user.name}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <Button variant="contained" fullWidth sx={{ mt: 2 }} onClick={onSubmit}>
        Submit Changes
      </Button>
    </Box>
  );
}
